import { Injectable } from '@angular/core';
import { OAuthOIDCBaseConfig } from './oidc.models';
import { environment } from 'src/environments/environment';
import { OiamEvents } from './oidc-events.enum';

@Injectable({
    providedIn: 'root',
})
export class OidcConfigService {

    constructor() {}


  setConfig(): OAuthOIDCBaseConfig {
    self.dispatchEvent(new CustomEvent(OiamEvents.OIAM_SET_CONFIG_EVENT,
      {detail: this._getConfig()}));
    if (window.location.href.includes('idst.ibaintern')) {
      console.log('Config gesetzt', this._getConfig());
    }
  return this._getConfig();
  }
  isValidCustomState(customState:string): boolean {
    return !!customState && customState.trim().length > 0;
  }
  private _getConfig(): OAuthOIDCBaseConfig {

    let config: OAuthOIDCBaseConfig = {
      clientid: environment.oidcClientId,
      //actingOnBehalfOf: ['urn:bafor:pmventerprise:partner:partnerid:'],
      logouturi: environment.uiHost,
      redirecturi: environment.uiHost,
      authnMethod: ["mfa"]
    };
    if (this.isValidCustomState(window.location.href.split(environment.uiHost)[1])) {
      config = {
        ...config,
        customstate: window.location.href.split(environment.uiHost)[1],
        redirecturi: environment.uiHost
      };
    } else {
      config = {
        ...config, redirecturi: window.location.href.split('?')[0]
      };
    }
    return config;
  }

}
